import { CustomMenuItemType } from '../custom-menu-items-type'
import { isSubOrGroupOrDynamicMenuType } from './custom-menu-item-type-guard'

type ChildType = CustomMenuItemType<'submenu' | 'group' | 'dynamic'>['children']

export type MenuNestedKeyReturnType = Map<
  string,
  { key: string; parentKeys: string[] }
>

const getKeysLvN = (
  children: ChildType,
  parentKeys: string[],
  result: MenuNestedKeyReturnType
): MenuNestedKeyReturnType => {
  children?.forEach((child) => {
    if (child?.key)
      result.set(child.key.toString(), {
        key: child.key.toString(),
        parentKeys,
      })

    if (
      isSubOrGroupOrDynamicMenuType(child) &&
      child.children &&
      child.children.length >= 1
    ) {
      getKeysLvN(
        child.children,
        child.key ? [...parentKeys, child.key.toString()] : parentKeys,
        result
      )
    }
  })

  return result
}

/** Lấy tất cả key của các items trong menu */
const getAllMenuNestedKeys = (
  menuItems: CustomMenuItemType[]
): MenuNestedKeyReturnType => {
  const result: MenuNestedKeyReturnType = new Map()

  menuItems.forEach((menu) => {
    if (menu?.key)
      result.set(menu.key.toString(), {
        key: menu.key.toString(),
        parentKeys: [],
      })

    if (
      isSubOrGroupOrDynamicMenuType(menu) &&
      menu.children &&
      menu.children.length >= 1
    ) {
      getKeysLvN(menu.children, menu?.key ? [menu.key.toString()] : [], result)
    }
  })

  return result
}

export default getAllMenuNestedKeys
